import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import {
  UpgradeButton,
  IfScope,
} from '@playbookux/playbook-web-core';

import {
  Container,
  Divider,
  Edit,
  Header,
  Title,
  SaveButton,
  ButtonsHeader,
  TitleSpan,
} from './styles';

const ProjectCard = (props) => {
  const {
    onSaveTemplate,
    editText,
    edit,
    icon,
    title,
    children,
    textButton,
    hasUpgrade,
    upgradeHandler,
    noLHeight,
    href,
    scope,
    type,
    completedTests,
    totalTests,
  } = props;

  return (
    <Container>
      <Header>
        <Title noLHeight={noLHeight}>
          {title}
          {hasUpgrade && (
            <UpgradeButton
              onClick={() => upgradeHandler()}
              pointer={+true}
              noMargin={+false}
            >
              Upgrade
            </UpgradeButton>
          )}

          {type && type !== 'moderated' && (
            <TitleSpan>
              {
                `(Completes: ${completedTests || 0}/${totalTests || 0})`
              }
            </TitleSpan>
          )}

        </Title>
        <IfScope user scope={scope}>
          <ButtonsHeader>
            {(edit || href) && (
              <Edit onClick={edit} href={href}>
                {editText || 'Edit'}
                &nbsp;
                {icon && <Icon name={icon} />}
              </Edit>
            )}

            {onSaveTemplate && (
              <SaveButton onClick={onSaveTemplate}>
                {textButton}
              </SaveButton>
            )}

          </ButtonsHeader>
        </IfScope>
      </Header>

      <Divider />

      <div>
        {children}
      </div>
    </Container>
  );
};

ProjectCard.propTypes = {
  children: PropTypes.node.isRequired,
  edit: PropTypes.func,
  editText: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ])),
  ]).isRequired,
  onSaveTemplate: PropTypes.func,
  isTemplateSaved: PropTypes.shape({}),
  textButton: PropTypes.string,
  hasUpgrade: PropTypes.bool,
  upgradeHandler: PropTypes.func,
  noLHeight: PropTypes.bool,
  href: PropTypes.string,
  scope: PropTypes.string.isRequired,
  type: PropTypes.string,
  completedTests: PropTypes.number,
  totalTests: PropTypes.number,
};

ProjectCard.defaultProps = {
  edit: null,
  editText: null,
  icon: null,
  onSaveTemplate: null,
  isTemplateSaved: null,
  textButton: '',
  hasUpgrade: false,
  upgradeHandler: () => { },
  noLHeight: false,
  href: null,
  type: null,
  completedTests: null,
  totalTests: null,
};

const mapStateToProps = (state) => ({
  scope: state.authentication && state.authentication.scope,
});

export default connect(mapStateToProps)(ProjectCard);
